
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { FloatingWhatsApp } from "@/components/FloatingWhatsApp";
import { AccessibilityButton } from "@/components/AccessibilityButton";
import { ContactHero, ContactCards, ContactForm, OfficeLocations } from "@/components/Contact";

export default function Contato() {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <div className="pt-24">
        <ContactHero />
        <ContactCards />
        <ContactForm />
        <OfficeLocations />
      </div>
      <Footer />
      <FloatingWhatsApp />
      <AccessibilityButton />
    </div>
  );
}
